module.exports = __webpack_public_path__ + "img/arrow_down.cc382df0.gif";